import EnumBase from './Base';

export default function userAcessTypeEnum(){
  return new EnumBase([
    { id: 'admin', name: 'Administrador' },
    { id: 'customer', name: 'Cliente' },
    { id: 'user', name: 'Usuário' },
  ]);
}
